import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/lib/apiClient";
import type { MessageMonitorResponse } from "@/types/messageMonitor";

// ─── Query keys ────────────────────────────────────────────────────────────────

export const messageMonitorKeys = {
  byRange: (startDate: string, endDate: string) =>
    ["message-monitor", startDate, endDate] as const
};

// ─── Queries ──────────────────────────────────────────────────────────────────

/**
 * Fetches messages for the given ISO date range.
 * Mirrors MessageMonitorService.GetMessagesByDateRangeAsync → GET /MessageMonitor?startDate=&endDate=
 */
export function useMessageMonitor(startDate: string, endDate: string) {
  return useQuery({
    queryKey: messageMonitorKeys.byRange(startDate, endDate),
    queryFn: () => {
      const qs = new URLSearchParams({
        startDate,
        endDate,
      });
      return apiGet<MessageMonitorResponse[]>(`MessageMonitor?${qs}`);
    },
    enabled: !!startDate && !!endDate && startDate <= endDate,
    staleTime: 30_000
  });
}
